<template>
  <layout-default-appbar filterabl v-if="isActive">
      Monitoramento
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { ROUTE_MONITORAMENTO } from '@/constants/ROUTES';
import ToggleAppBarEvent from '@/events/ToggleAppBarEvent';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultAppbar,
  },

    data() {
    return {
      rota: ROUTE_MONITORAMENTO,
      isActive: true,
    }
  }, 
  methods: {
    $_toggleNavigationDrawerHandler() {
      this.isActive = !this.isActive;
    },
  },
  created() {
   ToggleAppBarEvent.on(this.$_toggleNavigationDrawerHandler);
  },

  beforeDestroy(){
    ToggleAppBarEvent.off(this.$_toggleNavigationDrawerHandler);
  }

};
</script>
